import { useEffect, useState } from "react";
import Alert from "./components/Alert";
import History from "./components/History";
import SourceTab from "./components/SourceTab";
import ChangeSourceModal from "./components/ChangeSourceModal";
import ConfirmModal from "./components/ConfirmModal";
import { useUserInfo } from "../../../../context/user";
import axios from "axios";
import env from "../../../../config/env";
import toast from "react-hot-toast";

const ResetContext = () => {
  const BASE_URL = `${env.API_URL}/v1`;
  const [changeSourceModal, setChangeSourceModal] = useState(false);
  const [forceRefreshModal, setForceRefreshModal] = useState(false);
  const [tableData, setTableData] = useState(null);
  const userActiveLocation = useUserInfo()[4];
  const [refetch, setRefetch] = useState(false);
  const [loading, setLoading] = useState(false);

  const loadHistory = async () => {
    try {
      const response = await axios.get(
        `${BASE_URL}/users/get-sources/${userActiveLocation.id}`,
      );
      if (response?.data) {
        setTableData(response?.data?.data);
      }
    } catch (err) {
      console.log(err);
      toast.error(err.response.data.error.error || "Failed to load data");
    }
  };

  useEffect(() => {
    loadHistory();
  }, [refetch]);

  const handleOpenChangeSourceModal = () => {
    setChangeSourceModal(!changeSourceModal);
  };

  const handleOpenRefreshModal = () => {
    setForceRefreshModal(!forceRefreshModal);
  };

  const handleConfirmClick = async () => {
    setLoading(true);
    try {
      /* 🟢 onboarding API wrapped in try/catch */
      const response = await axios.post(`${BASE_URL}/users/onboarding`, {
        ...(tableData?.[0]?.website_url
          ? { website_url: tableData?.[0]?.website_url }
          : tableData?.[0]?.file_name
            ? { file_name: tableData?.[0]?.file_name }
            : { form: tableData?.[0]?.form }),
        profileId: userActiveLocation.id,
        username: userActiveLocation.business_name,
      });
      if (response?.data) {
        setRefetch(!refetch);
      }
    } catch (err) {
      toast.error(err.response.data.error.error || "Failed to load data");
      console.log(err);
    }
    setForceRefreshModal(false);
    setLoading(false);
  };

  return (
    <div>
      <h1 className="text-xl font-semibold my-6">Reset Context</h1>
      <Alert />
      <SourceTab
        currentSource={tableData?.[0]}
        onChangeSource={handleOpenChangeSourceModal}
        onForceRefresh={handleOpenRefreshModal}
      />
      <History tableData={tableData} />
      <ChangeSourceModal
        isOpen={changeSourceModal}
        onClose={handleOpenChangeSourceModal}
        currentSource={tableData?.[0]}
        refetch={refetch}
        setRefetch={setRefetch}
      />
      <ConfirmModal
        isOpen={forceRefreshModal}
        onClose={handleOpenRefreshModal}
        title="Force Refresh"
        onConfirm={handleConfirmClick}
        loading={loading}
      />
    </div>
  );
};

export default ResetContext;
